"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constant = require("../constant");
var getBandColor = function getBandColor(durationId, type) {
  if (type === _constant.opportunityTypes.INTERNSHIPS) {
    return 'linear-gradient(180deg, #FFD6C9 0%, #F28B2C 100%)';
  }
  if (type === _constant.opportunityTypes.EVENT) {
    return 'linear-gradient(180deg, #DEFFCA 0%, #3CDD22 100%)';
  }
  if (durationId === _constant.opportunityDuration.FULL_TIME) {
    return 'linear-gradient(180deg, #8EE1FB 0%, #0BBBF3 100%)';
  }
  if (durationId === _constant.opportunityDuration.PART_TIME) {
    return 'linear-gradient(180deg, #C8AEFF 0%, #A17BF2 100%)';
  }
  return 'linear-gradient(180deg, #DEFFCA 0%, #3CDD22 100%)';
};
var _default = getBandColor;
exports.default = _default;